import axiosInstance from './axiosInstance';
import { Category, CreateCategoryDto, UpdateCategoryDto } from '../types/categories.types';

export const categoriesService = {
  getAll: async (): Promise<Category[]> => {
    const response = await axiosInstance.get<Category[]>('/Categories');
    return response.data;
  },

  getById: async (id: number): Promise<Category> => {
    const response = await axiosInstance.get<Category>(`/Categories/${id}`);
    return response.data;
  },

  create: async (data: CreateCategoryDto): Promise<Category> => {
    const response = await axiosInstance.post<Category>('/Categories', data);
    return response.data;
  },

  update: async (id: number, data: UpdateCategoryDto): Promise<Category> => {
    const response = await axiosInstance.put<Category>(`/Categories/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/Categories/${id}`);
  },

  updateParent: async (categoryId: number, newParentId: number): Promise<void> => {
    await axiosInstance.patch(`/Categories/${categoryId}/parent`, { newParentId });
  },

  generateCode: async (parentCategoryId?: number): Promise<string> => {
    const params = parentCategoryId ? `?parentCategoryId=${parentCategoryId}` : '';
    const response = await axiosInstance.get<string>(`/Categories/generate-code${params}`);
    return response.data;
  },

  buildTree: (categories: Category[]): Category[] => {
    const categoryMap = new Map<number, Category>();
    const rootCategories: Category[] = [];
    
    categories.forEach(cat => {
      categoryMap.set(cat.categoryId, { ...cat, children: [] });
    });
    
    categories.forEach(cat => {
      const category = categoryMap.get(cat.categoryId)!;
      if (cat.parentCategoryId) {
        const parent = categoryMap.get(cat.parentCategoryId);
        if (parent) {
          parent.children!.push(category);
        }
      } else {
        rootCategories.push(category);
      }
    });
    
    return rootCategories;
  },
};